const VariantTitle = (props) => {
  const { variant } = props;
  return (
    <span className="c7-product__variant__price__title">{variant.title}</span>
  );
};

export default VariantTitle;
